import {PerformanceDisclosureData} from '../disclosureData'
import React from 'react'
import styles from './PerformanceDisclosure.module.scss'
const PerformanceDisclosure = () => {
  return <div className={styles.PerformanceDisclosure}><div className={styles.text} dangerouslySetInnerHTML={{__html: PerformanceDisclosureData}} /></div>
}
export default PerformanceDisclosure
